var map = {
	"./Brume-Regular.woff": 6749,
	"./Geist-Bold.woff": 2059,
	"./Geist-Medium.woff": 9327,
	"./Geist-Regular.woff": 9973,
	"./Geist-SemiBold.woff": 5080,
	"./Herokid-Bold.woff": 5351,
	"./Herokid-Regular.woff": 8386,
	"./Herokid-SemiBold.woff": 8639,
	"./Herokid-SemiBoldNarrow.woff": 3884,
	"./Inter_18pt-SemiBold.woff": 4707,
	"./Montserrat-Bold.woff": 1878,
	"./Poppins-Bold.woff": 4099,
	"./Poppins-Medium.woff": 7980,
	"./Poppins-Regular.woff": 3466,
	"./Poppins-SemiBold.woff": 3861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3776;